import script from "./ShowTrailerPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowTrailerPage.vue?vue&type=script&setup=true&lang=ts"

import "./ShowTrailerPage.vue?vue&type=style&index=0&id=2b7e6280&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b7e6280"]])

export default __exports__